import { render } from "./KpsBorderViolationsView.vue?vue&type=template&id=70b4f33a&scoped=true"
import script from "./KpsBorderViolationsView.vue?vue&type=script&lang=js"
export * from "./KpsBorderViolationsView.vue?vue&type=script&lang=js"

import "./KpsBorderViolationsView.vue?vue&type=style&index=0&id=70b4f33a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b4f33a"]])

export default __exports__